function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { colors } from '@keen.io/colors';
import { useTranslation } from 'react-i18next';
import { useSearch, useKeypress } from '@keen.io/react-hooks';
import { BodyText } from '@keen.io/typography';
import { Dropdown, Tooltip, DropableContainer, EmptySearch, TitleComponent, KEYBOARD_KEYS } from '@keen.io/ui-core';
import { ListItem, ScrollWrapper } from './components';
import { Container, List, Groups, TooltipContainer } from './Analysis.styles';
import { hintMotion } from './motion';
import { transformName, scrollToActiveElement } from './utils';
import { ANALYSIS_GROUPS } from './constants';

var Analysis = function Analysis(_ref) {
  var analysis = _ref.analysis,
      onChange = _ref.onChange;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectionIndex = _useState4[0],
      setIndex = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hint = _useState6[0],
      _showHint = _useState6[1];

  var _useState7 = useState(ANALYSIS_GROUPS),
      _useState8 = _slicedToArray(_useState7, 2),
      filteredAnalysis = _useState8[0],
      setFilteredAnalysis = _useState8[1];

  var _useState9 = useState({
    top: 0,
    bottom: 0,
    height: 0,
    overflow: false
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      tooltip = _useState10[0],
      setTooltip = _useState10[1];

  var options = useMemo(function () {
    return ANALYSIS_GROUPS.flatMap(function (item) {
      return item;
    });
  }, []);
  var tooltipRef = useRef(null);
  var dropdownRef = useRef(null);
  var scrollRef = useRef(null);

  var _useSearch = useSearch(options, function (searchResult, phrase) {
    setIndex(null);

    if (phrase) {
      var indexedResults = searchResult.map(function (item, idx) {
        return _objectSpread(_objectSpread({}, item), {}, {
          index: idx
        });
      });
      setFilteredAnalysis([indexedResults]);
    } else {
      setFilteredAnalysis(ANALYSIS_GROUPS);
    }
  }),
      searchHandler = _useSearch.searchHandler,
      searchPhrase = _useSearch.searchPhrase,
      clearSearchPhrase = _useSearch.clearSearchPhrase;

  var _filteredAnalysis = _slicedToArray(filteredAnalysis, 1),
      firstGroup = _filteredAnalysis[0];

  var keyboardHandler = useCallback(function (_e, keyCode) {
    var analyses = filteredAnalysis.flatMap(function (item) {
      return item;
    });

    switch (keyCode) {
      case KEYBOARD_KEYS.ENTER:
        var _analysis = analyses.find(function (_ref2) {
          var index = _ref2.index;
          return index === selectionIndex;
        });

        if (_analysis) {
          var value = _analysis.value;
          onChange(value);
          setOpen(false);
        }

        break;

      case KEYBOARD_KEYS.UP:
        if (selectionIndex > 0) {
          setIndex(selectionIndex - 1);
        }

        break;

      case KEYBOARD_KEYS.DOWN:
        if (selectionIndex === null) {
          setIndex(0);
        } else if (selectionIndex < analyses.length - 1) {
          setIndex(selectionIndex + 1);
        }

        break;

      case KEYBOARD_KEYS.ESCAPE:
        setOpen(false);
        break;
    }
  }, [selectionIndex, filteredAnalysis]);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ENTER, KEYBOARD_KEYS.ESCAPE, KEYBOARD_KEYS.UP, KEYBOARD_KEYS.DOWN],
    addEventListenerCondition: isOpen,
    eventListenerDependencies: [isOpen, selectionIndex, filteredAnalysis]
  });
  useEffect(function () {
    if (dropdownRef.current && hint && tooltipRef.current && scrollRef.current) {
      var height = tooltipRef.current.clientHeight;

      var _dropdownRef$current$ = dropdownRef.current.getBoundingClientRect(),
          top = _dropdownRef$current$.top,
          bottom = _dropdownRef$current$.bottom;

      var scrollTop = scrollRef.current.offsetParent ? scrollRef.current.offsetParent.scrollTop : 0;
      setTooltip(function (state) {
        var tooltipBottom = top + state.top + height;
        var overflow = bottom + scrollTop < tooltipBottom;
        return _objectSpread(_objectSpread({}, state), {}, {
          overflow: overflow,
          height: height,
          top: state.top - scrollTop,
          bottom: state.bottom - scrollTop
        });
      });
    }
  }, [tooltipRef, dropdownRef, scrollRef, hint]);
  useEffect(function () {
    if (isOpen) {
      var _options$find = options.find(function (_ref3) {
        var value = _ref3.value;
        return value === analysis;
      }),
          index = _options$find.index;

      setIndex(index);
    } else {
      clearSearchPhrase();
      setFilteredAnalysis(ANALYSIS_GROUPS);
    }
  }, [isOpen]);
  return React.createElement(Container, {
    role: "listbox"
  }, React.createElement(TitleComponent, {
    onClick: function onClick() {
      return setOpen(true);
    }
  }, t('query_creator_analysis.label')), React.createElement(DropableContainer, {
    onClick: function onClick() {
      return !isOpen && setOpen(true);
    },
    searchPlaceholder: t('query_creator_analysis.search_placeholder'),
    placeholder: t('query_creator_analysis.placeholder'),
    isActive: isOpen,
    value: transformName(analysis),
    dropIndicator: true,
    searchable: true,
    onSearch: searchHandler,
    variant: "secondary",
    onDefocus: function onDefocus() {
      setOpen(false);
    }
  }, React.createElement(BodyText, {
    variant: "body2",
    color: colors.blue[500],
    style: {
      textTransform: 'capitalize'
    }
  }, transformName(analysis))), React.createElement(Dropdown, {
    ref: dropdownRef,
    isOpen: isOpen
  }, searchPhrase && !firstGroup.length ? React.createElement(EmptySearch, {
    message: t('query_creator_analysis.empty_search_results')
  }) : React.createElement(ScrollWrapper, {
    ref: scrollRef
  }, React.createElement(Groups, null, filteredAnalysis.map(function (options, idx) {
    return React.createElement(List, {
      key: idx,
      role: "list"
    }, options.map(function (_ref4) {
      var label = _ref4.label,
          value = _ref4.value,
          index = _ref4.index,
          description = _ref4.description;
      return React.createElement(ListItem, {
        key: value,
        isActive: selectionIndex === index,
        onActive: function onActive(activeElementRef) {
          return scrollToActiveElement(activeElementRef, scrollRef);
        },
        description: t(description),
        analysis: value,
        onMouseEnter: function onMouseEnter() {
          return setIndex(index);
        },
        onClick: function onClick(_e, analysis) {
          setOpen(false);
          onChange(analysis);
        },
        showHint: function showHint(value, topPos, bottomPos) {
          if (topPos !== 0 && bottomPos !== 0 && value) {
            setTooltip(function (state) {
              return _objectSpread(_objectSpread({}, state), {}, {
                top: topPos,
                bottom: bottomPos
              });
            });
          }

          _showHint(value);
        }
      }, label);
    }));
  }))), hint && React.createElement(TooltipContainer, Object.assign({
    ref: tooltipRef,
    "data-testid": "hint-message",
    key: "tooltip-container"
  }, hintMotion, {
    tooltipY: tooltip.overflow ? tooltip.bottom - tooltip.height : tooltip.top
  }), React.createElement(Tooltip, {
    mode: "dark",
    hasArrow: false
  }, React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: t(options[selectionIndex].description)
    }
  })))));
};

export default Analysis;